/** Comparte la consulta entre pantallas sin persistir respuestas ni credenciales. */
export function createAndroidUpdateCheck({ load, now = Date.now, retryMs = 30000 }) {
    let current = null;
    return {
        check({ token, currentVersion = null, maxAgeMs = 900000, force = false }) {
            const key = `${token || ''}|${currentVersion || ''}`;
            if (!current || current.key !== key) current = { key, pending: null, completedAt: null, data: null, error: null };
            const entry = current;
            if (entry.pending) return entry.pending;
            if (!force && entry.completedAt !== null && now() - entry.completedAt < (entry.error ? retryMs : maxAgeMs)) {
                return entry.error ? Promise.reject(entry.error) : Promise.resolve(entry.data);
            }
            entry.pending = Promise.resolve().then(() => load({ token, currentVersion })).then(data => {
                entry.data = data; entry.error = null; entry.completedAt = now(); return data;
            }, error => {
                entry.error = error; entry.completedAt = now(); throw error;
            }).finally(() => { entry.pending = null; });
            return entry.pending;
        },
    };
}
